<template>
  <div>
    <!-- :before-close="handleClose" -->
    <el-drawer
      :title="title"
      :visible.sync="drawer"
      size="800px"
      :wrapperClosable="false"
    >
      <div class="form-center" v-loading="loading">
        <el-form :model="form" ref="form" label-width="140px" :rules="rules">
          <!-- <el-form-item label="头像" prop="HeadImg" class="Describe">
            <el-upload
              class="avatar-uploader"
              :action="$rootUrl + `/Base_Manage/Upload/UploadFileByForm`"
              :headers="{
                Authorization: token,
              }"
              :show-file-list="false"
              :on-success="handleAvatarSuccess"
              :before-upload="beforeAvatarUpload"
            >
              <el-image
                v-if="form.HeadImg"
                fit="contain"
                class="HeadImg"
                :src="form.HeadImg"
              ></el-image>
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item> -->
          <el-form-item label="页面名称" prop="Name">
            <el-input
              v-model="form.Name"
              placeholder="请输入页面名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="页面类型" prop="Type">
            <el-radio-group v-model="form.Type" @change="TypeChange">
              <el-radio :label="0">菜单</el-radio>
              <el-radio :label="1">页面</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="页面路径" prop="Url" v-if="form.Type === 1">
            <el-input
              v-model="form.Url"
              placeholder="请输入页面路径"
            ></el-input>
          </el-form-item>
          <el-form-item label="父级菜单">
            <!-- <el-input
              v-model="form.Url"
              placeholder="请输入页面路径"
            ></el-input> -->
            <el-cascader
              clearable
              v-model="form.ParentId"
              :options="TreeData"
              filterable
              :props="{
                emitPath: false,
                expandTrigger: 'hover',
                children: 'Children',
                label: 'title',
                value: 'Id',
                checkStrictly: true,
              }"
              style="width: 100%"
            ></el-cascader>
          </el-form-item>

          <el-form-item
            label="左侧菜单类型"
            prop="TreeDataType"
            v-if="form.Type === 1"
          >
            <el-radio-group v-model="form.TreeDataType">
              <el-radio :label="0">无</el-radio>
              <el-radio :label="1">楼号设备分类</el-radio>
              <el-radio :label="2">备件分类</el-radio>
              <el-radio :label="3">资产分类</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="图标Icon" prop="Icon">
            <i :class="form.Icon" style="margin-right: 10px"></i>
            <el-input
              v-model="form.Icon"
              placeholder="请输入图标Icon"
              style="width: 300px"
            ></el-input>
            <el-button @click="openIcon" icon="el-icon-search" type="primary"
              >选择图标</el-button
            >
          </el-form-item>
          <el-form-item label="排序" prop="Sort">
            <el-input-number
              v-model="form.Sort"
              placeholder="请输入排序"
            ></el-input-number>
          </el-form-item>
        </el-form>
      </div>
      <div class="footer" v-loading="loading">
        <el-button @click="close">取消</el-button>
        <el-button type="primary" @click="handleSubmit">保存</el-button>
      </div>
    </el-drawer>
    <EleIcon ref="EleIcon" @confirm="EleIconChange"></EleIcon>
  </div>
</template>
<script>
import Token from '@/utils/cache/TokenCache.js'
import EleIcon from '@/components/EleIcon/EleIcon.vue'
export default {
  data() {
    return {
      title: '',
      loading: false,
      token: 'Bearer ' + Token.getToken(),
      RoleList: [],
      form: {
        Name: '',
        ParentId: '',
        Icon: '',
        Sort: '',
        TreeDataType: '',
        Type: '',
        Url: '',
      },
      TreeData: [],
      rules: {
        // UserCode: [{ required: true, message: "请输入用户编号", trigger: "blur" }],
        Name: [{ required: true, message: '请输入页面名称', trigger: 'blur' }],
        Url: [{ required: true, message: '请输入页面路径', trigger: 'blur' }],
        ParentId: [
          { required: true, message: '请选择父级菜单', trigger: 'cahnge' },
        ],
        TreeDataType: [
          { required: true, message: '请选择左侧菜单类型', trigger: 'cahnge' },
        ],
        // Telephone: [
        //   { required: true, message: "请输入手机号", trigger: "blur" },
        //   // { min: 11, max: 11, message: "长度为 11 位", trigger: "blur" },
        // ],
        Type: [
          { required: true, message: '请选择页面类型', trigger: 'change' },
        ],
        // Sex: [{ required: true, message: "请选择性别", trigger: "change" }],
        EmployeStatus: [
          { required: true, message: '请选择状态', trigger: 'blur' },
        ],
      },
      drawer: false,
    }
  },
  props: {},
  components: { EleIcon },
  methods: {
    EleIconChange(a) {
      this.form.Icon = a
    },
    openIcon() {
      this.$refs.EleIcon.openDialog()
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 20

      if (!isJPG) {
        this.$notify.error('上传图片只能是 JPG 或 PNG 格式!')
      }
      if (!isLt2M) {
        this.$notify.error('上传头像图片大小不能超过 20MB!')
      }
      return isJPG && isLt2M
    },
    handleAvatarSuccess(res) {
      console.log(res, 'res')
      if (res.status == 'done') {
        this.form.HeadImg = res.url

        console.log(this.form.HeadImg)
      } else {
        this.$notify.error(res.Msg)
      }
    },
    getRoleList() {
      this.$http
        .post('/Base_Manage/Base_Role/GetDataList', {
          SortField: 'CreateTime',
          SortType: 'Desc',
        })
        .then((resJson) => {
          if (resJson.Success) {
            this.RoleList = resJson.Data
          }
        })
    },
    handleSubmit() {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return this.$notify.error('请检查输入项')
        }
        this.loading = true
        this.$http
          .post('/Base_Manage/Base_Action/SaveData', {
            ...this.form,
          })
          .then((resJson) => {
            this.loading = false
            if (resJson.Success) {
              this.$notify.success('操作成功!')
              this.$emit('success')
              this.close()
            } else {
              this.$notify.error(resJson.Msg)
            }
          })
      })
    },
    TypeChange() {
      this.form.Url = ''
    },
    openForm(title, row = {}, TreeData) {
      this.drawer = true
      this.TreeData = TreeData
      // this.getRoleList();
      this.form = {
        Name: '',
        ParentId: '',
        Icon: 'el-icon-s-home',
        Sort: '',
        TreeDataType: 0,
        Type: '',
        Url: '',
      }
      this.$nextTick(() => {
        this.$refs.form.resetFields()
      })
      this.title = title
      if (row.Id) {
        this.getInfo(row.Id)
      }
    },
    getInfo(id) {
      this.loading = true
      this.$http
        .post('/Base_Manage/Base_Action/GetTheData', { id: id })
        .then((resJson) => {
          this.loading = false
          if (resJson.Success) {
            this.form = {
              ...resJson.Data,
            }
          } else {
            this.$notify.error(resJson.Msg)
          }
        })
    },
    close() {
      this.drawer = false
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(() => {
          done()
        })
        .catch(() => {})
    },
  },
  mounted() {},
  created() {},
  computed: {},
  watch: {},
}
</script>
<style lang="scss" scoped>
::v-deep .el-drawer__header {
  margin: 0;
  padding: 20px;
}
.form-center {
  height: calc(100vh - 120px);
  padding: 20px;
}
.footer {
  height: 40px;
  line-height: 40px;
  text-align: right;
  padding: 0 20px;
}
::v-deep .avatar-uploader .el-upload {
  width: 100px;
  height: 100px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

::v-deep .avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 65px;
  height: 60px;
  line-height: 60px;
  text-align: center;
}
</style>
